import { FC } from 'react';
import { ScoreTitleStyled } from './style';

const ScoreTitle: FC = ({ children, ...restProps }) => <ScoreTitleStyled {...restProps}>{children}</ScoreTitleStyled>;

export default ScoreTitle;
